/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react'
import {TextField, TextFieldProps} from "@mui/material";
import {styled} from "@mui/material/styles";

const textFieldMarginTop = '0.35em'
const StyledTextField = styled(TextField)({
  marginTop: textFieldMarginTop
})
const ArgosTextField = (props: TextFieldProps) => {
  return (
    <StyledTextField variant="outlined" size="small" value={props.value} label={props.label} disabled={props.disabled}
                     {...props}
    />
  )
}

export default ArgosTextField